<template>
  <v-data-table
    class="services-table"
    :headers="headers"
    :items="positions"
    hide-actions
    expand
    item-key="index"
  >
    <template v-slot:items="props">
      <tr :class="{ 'expanded': props.expanded }" class="t-row" @click="props.expanded = !props.expanded">
        <td class="expander">
          <v-btn icon @click.stop="props.expanded = !props.expanded" class="expander">
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </td>
        <td class="report-state">
          <v-icon
            v-if="props.item.errors && props.item.errors.length > 0"
            color="error"
          >error</v-icon>
          <v-icon
            v-else-if="props.item.warnings && props.item.warnings.length > 0"
            color="warning"
          >warning</v-icon>
        </td>
        <td>{{ props.item.date | moment("DD.MM.YYYY") }}</td>
        <td>{{ props.item.code }}</td>
        <td>{{ props.item.ref_code }}</td>
        <td>{{ props.item.session }}</td>
        <td>{{ props.item.quantity }}</td>
        <td class="actions justify-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                primary
                class="mx-0"
                @click.stop="editPosition(props.item)"
                v-on="on"
              >
                <v-icon
                  small
                  color="grey darken-1"
                >edit</v-icon>
              </v-btn>
            </template>
            <span>Bearbeiten</span>
          </v-tooltip>
          <v-menu
              v-model="props.item.deleteMenu"
              lazy
              offset-y
              :close-on-content-click="false"
              style="background-color: white"
          >
            <template v-slot:activator="{ on: menu }">
              <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    icon
                    class="mx-0"
                    v-on="{ ...tooltip, ...menu }"
                    @click.stop
                  >
                    <v-icon
                      small
                      color="grey darken-1"
                    >delete</v-icon>
                  </v-btn>
                </template>
                <span>Löschen</span>
              </v-tooltip>
            </template>
            <v-card>
              <v-card-text>
                Wollen Sie den Eintrag wirklich löschen?
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="props.item.deleteMenu = false">Nein</v-btn>
                <v-btn flat color="error" @click="deletePosition(props.item)">Löschen</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </td>
      </tr>
    </template>
    <template v-slot:expand="props">
      <v-card flat>
        <v-card-text>
          <h3>{{ props.item.title }}</h3>
          <v-alert
            v-if="props.item.errors.length > 0"
            class="report-alert elevation-1"
            :value="props.item.errors.length > 0"
            type="error"
            outline
          >
            <p class="mb-0">Fehler:</p>
            <ul>
              <li :key="index" v-for="(error, index) in props.item.errors">
                {{ error.message }}
                <br />
                <p v-if="error.rules && error.rules.length > 0" class="mb-0">Regeln:</p>
                <ul>
                  <li :key="ruleIndex" v-for="(rule, ruleIndex) in error.rules">{{ rule }}</li>
                </ul>
              </li>
            </ul>
            <!--
            <code>{{ props.item.errors[0].rules }}</code>
            <code>{{ props.item.errors }}</code>
            -->
            <div class="report-alert-border"></div>
          </v-alert>
          <v-alert
            v-if="props.item.warnings.length > 0"
            class="report-alert elevation-1"
            :value="props.item.warnings.length > 0"
            type="warning"
            outline
          >
            <p class="mb-0">Warnungen:</p>
            <ul>
              <li :key="index" v-for="(warning, index) in props.item.warnings">
                {{ warning.message }}
                <br />
                <p v-if="warning.rules && warning.rules.length > 0" class="mb-0">Regeln:</p>
                <ul>
                  <li :key="ruleIndex" v-for="(rule, ruleIndex) in warning.rules">{{ rule }}</li>
                </ul>
              </li>
            </ul>
            <div class="report-alert-border"></div>
          </v-alert>
        </v-card-text>
      </v-card>
    </template>
    <template v-slot:no-data>
      <v-alert :value="true" type="info">
        Es sind noch keine Leistungen erfasst. Klicken Sie auf "Hinzufügen" um Leistungen zu erfassen.
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>

export default {
  props: {
    positions: {
      type: Array,
      required: true
    },
    loading: Boolean
  },

  data() {
    return {
      headers: [
        { text: " ", value: "id", sortable: false },
        { text: " ", value: "reportState", sortable: false, class: "report-state" },
        { text: "Datum", value: "date", sortable: false },
        { text: "Tarifziffer", value: "code", sortable: false },
        { text: "Bezugsziffer", value: "ref_code", sortable: false },
        { text: "Sitzung", value: "session", sortable: false },
        { text: "Anzahl", value: "quantity", sortable: false },
        { text: "Aktionen", value: "id", sortable: false, class: "actions" }
      ]
    }
  },

  methods: {
    editPosition(position) {
      this.$emit("edit-position", position)
    },

    deletePosition(position) {
      this.$emit("delete-position", position)
    },
  }
}
</script>

<style scoped>
/* bugfix: expandable rows should have border-top not border-bottom */
div.services-table >>> .theme--light.v-table tbody tr.t-row:not(:last-child) {
  border-bottom: transparent;
}
div.services-table >>> .theme--light.v-table tbody tr.t-row:not(:first-child) {
  border-top: 1px solid #c5c5c5;
}

/* resets for lay out chevron and report state icons in position rows */
div.services-table >>> tr.t-row td.expander {
  width: 55px;
  padding-left: 0;
  padding-right: 0;
}
tr.t-row td.expander .layout:only-child {
  margin: 0;
}
tr.t-row td.expander .v-input.v-input--checkbox {
  flex-grow: 0;
}
tr.t-row td.report-state, div.services-table >>> th.report-state {
  padding-left: 0;
  padding-right: 0;
  width: 24px;
}

tr.t-row td.actions {
  min-width: 130px;
  text-align: center;
}

div.services-table >>> th.actions {
  text-align: center !important;
}

tr.expanded .expander .v-icon {
  transform: rotate(90deg);
}

/* report alerts/notifications */
.report-alert-border {
  left: 0;
  top: 0;
  bottom: 0;
  border-style: solid;
  border-width: 4px;
  content: "";
  position: absolute;
  opacity: 0.25;
}
div.report-alert {
  border: none !important;
}
div.report-alert >>> div p, div.report-alert >>> div ul, div.report-alert >>> div h3 {
  color: rgba(0,0,0,0.87);
}
div.report-alert.v-alert >>> .v-alert__icon.v-icon {
  align-self: start !important;
}
</style>

